import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import { Card, FlexBox } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { UserAvatar } from 'shared/components/UserAvatar/UserAvatar'
import { blueGray, primaryBlack, royalBlue } from 'shared/theme/colors'
import styled from 'styled-components'

import { Job } from 'models/jobs'
import { UserSidebar } from '../../Sidebar/UserSidebar'
import { ClickToCopyJobInfo } from '../ClickToCopyJobInfo'
import { EditAssignedDriverButton } from './EditAssignedDriverButton'
import { EditAssignedTruckButton } from './EditAssignedTruckButton'

interface JobDriverCardProps {
  job: Job
}

export function JobDriverCard({ job }: JobDriverCardProps) {
  return (
    <Card fullWidth smallerPadding noShadow height="fit-content">
      <FlexBox isColumn alignItems="stretch" gap="24px">
        <FlexBox isColumn alignItems="stretch" gap="20px">
          <FlexBox justifyContent="space-between" alignItems="center" gap="12px">
            <UserAvatar
              userName={`${job.assigned_to.first_name} ${job.assigned_to.last_name}`}
              width="24px"
              height="24px"
              borderWidth="1px"
              fontSize="9px"
              variant="standard"
            />
            <FlexBox flex={1}>
              <UserSidebar userId={job.assigned_to.id}>
                <Text
                  variant="header3"
                  fontColor={primaryBlack}
                  style={{ flex: 1, cursor: 'pointer' }}
                  align="left"
                >
                  {job.assigned_to.first_name} {job.assigned_to.last_name}
                </Text>
              </UserSidebar>
            </FlexBox>
            <EditAssignedDriverButton job={job} iconColor={blueGray} />
          </FlexBox>

          <FlexBox justifyContent="space-between" alignItems="center" gap="12px">
            <TruckIcon fontSize="medium" />
            {job.assigned_truck ? (
              <Text variant="header3" fontColor={primaryBlack} style={{ flex: 1 }} align="left">
                {[
                  job?.assigned_truck?.vehicle_year,
                  job?.assigned_truck?.vehicle_make,
                  job?.assigned_truck?.vehicle_model,
                ]
                  .filter((x) => !!x)
                  .join(' ')
                  .trim()}
              </Text>
            ) : (
              <Text variant="header3" fontColor={primaryBlack} style={{ flex: 1 }} align="left">
                No truck assigned
              </Text>
            )}
            <EditAssignedTruckButton job={job} iconColor={blueGray} />
          </FlexBox>
        </FlexBox>

        {/* TODO: @public-console-job-details-redesign copy driver contact & eld text here ??? */}
        <ClickToCopyJobInfo record={job} textProps={{ variant: 'header4' }}>
          <Text variant="header4" fontColor={royalBlue} align="left" style={{ cursor: 'pointer' }}>
            Copy info
          </Text>
        </ClickToCopyJobInfo>
      </FlexBox>
    </Card>
  )
}

const TruckIcon = styled(LocalShippingIcon)`
  margin-top: 2px;
  color: ${blueGray};
`
